<template>
    <div class="modal-overlay" @click.self="closeModal">
        <div class="modal">
            <div class="modal-header">
              <h2 class="modal-title"><slot name="title">Código de Sesión</slot></h2>
               <span class="close-button" @click="closeModal">×</span>
            </div>
            <div class="modal-content">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        closeModal() {
            this.$emit('close');
        }
    }
};
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal {
    background: white;
     border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    position: relative;
    max-width: 500px;
    width: 90%;
    font-family: 'Roboto', sans-serif;
    display: flex;
    flex-direction: column;

}
.modal-header{
    display: flex;
    justify-content: space-between;
    padding: 20px;
    border-bottom: 1px solid #e0e0e0;
    align-items: center;
}
.modal-title{
     font-family: 'Oswald', sans-serif;
    font-size: 1.5em;
    color: #333;
     margin-bottom: 0;
}

.modal-content {
     padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 15px; /* Espacio entre elementos dentro del modal-content */
}

.close-button {
    font-size: 24px;
    cursor: pointer;
    color: #aaa;
    transition: color 0.2s ease;
     line-height: 1; /* Añadido */
}
.close-button:hover {
    color: #555;
}
</style>